import {
  faArrowDownAZ,
  faArrowUpAZ,
  faArrowDownWideShort,
  faArrowUpWideShort,
} from '@fortawesome/pro-solid-svg-icons';

// Column mapping for lead properties
export const COLUMN_KEY_TO_PROPERTY_MAP = {
  'companyName': 'contactCompanyName',
  'name': 'displayName',
  'leadStatus': 'leadStatusLabel',
  'pageViews': 'pageViews',
  'lastAction': 'lastActionLabel',
  'notes': 'notes'
};

// Column definitions with sorting configuration
export const LEAD_COLUMNS = {
  company: {
    header: 'Company',
    key: 'companyName',
    sortable: true,
    icon: {
      asc: faArrowUpAZ,
      desc: faArrowDownAZ
    }
  },
  name: {
    header: 'Name',
    key: 'name',
    sortable: true,
    icon: {
      asc: faArrowUpAZ,
      desc: faArrowDownAZ
    }
  },
  leadStatus: {
    header: 'Lead Status',
    key: 'leadStatus',
    sortable: true,
    icon: {
      asc: faArrowUpWideShort,
      desc: faArrowDownWideShort
    }
  },
  pageViews: {
    header: 'Page Views',
    key: 'pageViews',
    sortable: true,
    icon: {
      asc: faArrowUpWideShort,
      desc: faArrowDownWideShort
    }
  },
  lastAction: {
    header: 'Last Action',
    key: 'lastAction',
    sortable: true,
    icon: {
      asc: faArrowUpWideShort,
      desc: faArrowDownWideShort
    }
  },
  notes: {
    header: 'Notes',
    key: 'notes',
    sortable: false
  }
};

// Default page size for pagination
export const DEFAULT_PAGE_SIZE = 5;
